import * as React from 'react';
import { ReactComponent as TextObservationIconSVG } from '../../assets/icons/mevo/ic_text_observation.svg';
import IconPattern, { IconProps } from './_IconPattern';

const TextObservationIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={TextObservationIconSVG} variantPlaces={2} {...props} />;
};

export default TextObservationIcon;
